import React from "react";
import ILoginForm from "components/LoginForm/ILoginForm";

import useWindowDimensions from "utils/WindowSize";
import { Form, Input, message } from "antd";
import { CustomButton, HrText } from "core/interfaces/components/index";
import { AuthRepository } from "core/data";
import i18n from "utils/i18n";
import { ILoginRequest } from "core/interfaces/data/IAuthRequest";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { Enhanced } from "utils/ReactUtils";

const LoginForm: React.FC<ILoginForm> = ({ OnLoginSuccess, OnChangePasswordRequest ,t,sessionInfo}) => {
	

	const { width } = useWindowDimensions();

	const OnLogin = async (data: ILoginRequest) => {
		const login = await AuthRepository.Login({
			Username: data.Username,
			Password: data.Password,
			culture: i18n.language,
			IdSessione: sessionInfo.sessione?.idSessione,
		});

		if (!login || !login.logged) {
			message.error(t("auth.loginFailed"));
		} else {
			OnLoginSuccess(login.nomeUtente!);
			if (login.cambiopasswordRichiesto) OnChangePasswordRequest(true, data.Password);
		}
	};

	return (
		<Form onFinish={OnLogin} style={{ width: "100%" }} className="login-form-container">
			<HrText text={width > 500 ? t("login.subtitle") : t("login.subtitle").split(" ")[0]} />
			<div className="login-form">
				<Form.Item name="Username" rules={[{ required: true, message: t("login.messagges.username") }]}>
					<div className="input">
						<Input size="large" className={"input-auth"} placeholder="User ID" />
					</div>
				</Form.Item>
				<Form.Item name="Password" rules={[{ required: true, message: t("login.messagges.password") }]}>
					<div className="input">
						<Input.Password size="large" className={"input-auth"} placeholder="Password" />
					</div>
				</Form.Item>
				<div className="forgotPwd link">
					<span
						className="link"
						onClick={() => {
							OnChangePasswordRequest(false);
						}}
						role="button"
						onKeyDown={(event) =>{ if (event.key === "Enter") {OnChangePasswordRequest(false)}}}
						tabIndex={0} 
					>
						{t("login.forgotPwd")}
					</span>
				</div>
				<div className="loginBtn">
					<CustomButton text={t("login.login")} style={{ width: "100%" }} htmlType="submit" buttonType={CustomButtonType.positive} />
				</div>
			</div>
		</Form>
	);
};

export default Enhanced( LoginForm,{componentNamespace:"LoginForm"});
